import React from "react";

import { AccountSettings } from "@akj-dev/affinity-platform";
import {
  AffinitySalesIcon,
  AffinityOrderIcon,
  AffinityInsightIcon,
  AffinityBillingIcon,
  AffinitySupportIcon,
  AffinityHubIcon,
  AffinityCustomersIcon,
  AffinityHomeIcon,
  affinityColors as colors
} from "@akj-dev/design-system";

type PlatformMenuItemFlash = {
  primary: string;
  secondary: string;
};

type PlatformMenuItem = {
  icon: React.ReactElement;
  label: string;
  subDomain?: string;
  pathname: string;
  flash?: PlatformMenuItemFlash;
  permissions?: (keyof AccountSettings)[];
};

export const platformMenuItems: PlatformMenuItem[] = [
  {
    icon: <AffinityHomeIcon />,
    label: "Home",
    pathname: "/"
  },
  {
    icon: <AffinityCustomersIcon />,
    label: "Customers",
    subDomain: "customers",
    pathname: "/customers",
    permissions: ["can_use_affinity_customers"]
  },
  {
    icon: <AffinitySalesIcon />,
    label: "Sales",
    subDomain: "sales",
    pathname: "/sales",
    flash: {
      primary: colors.affinityBlueDark.value,
      secondary: colors.affinityBlueLight.value
    },
    permissions: ["can_use_affinity_sales"]
  },
  {
    icon: <AffinityOrderIcon />,
    label: "Orders",
    subDomain: "orders",
    pathname: "/orders",
    flash: {
      primary: colors.affinityTealDark.value,
      secondary: colors.affinityTealLight.value
    },
    permissions: ["can_use_affinity_orders"]
  },
  {
    icon: <AffinityBillingIcon />,
    label: "Billing",
    subDomain: "billing",
    pathname: "/billing",
    flash: {
      primary: colors.affinityGreenDarker.value,
      secondary: colors.affinityGreenLighter.value
    },
    permissions: ["can_use_affinity_billing"]
  },
  {
    icon: <AffinityInsightIcon />,
    label: "Insight",
    subDomain: "insight",
    pathname: "/insight",
    flash: {
      primary: colors.affinityVioletDark.value,
      secondary: colors.affinityVioletLight.value
    },
    permissions: ["can_use_affinity_insight"]
  },
  {
    icon: <AffinityHubIcon />,
    label: "Hub",
    subDomain: "hubinfo",
    pathname: "/hub",
    flash: {
      primary: colors.affinityPinkDarker.value,
      secondary: colors.affinityPinkLighter.value
    },
    permissions: ["can_use_affinity_hub"]
  },
  {
    icon: <AffinitySupportIcon />,
    label: "Support",
    subDomain: "support",
    pathname: "/support",
    flash: {
      primary: colors.affinityOrangeDark.value,
      secondary: colors.affinityOrangeLight.value
    },
    permissions: ["can_use_affinity_support", "can_use_affinity_support_new"]
  }
];
